<script>
  import Button from '../Button'

  export let onClose
</script>

<div class='modal-backlink'>
  <Button on:click={onClose} variant='link'>
    &lt; Back
  </Button>
</div>

<style>

.modal-backlink {
  position: relative;
  padding: var(--spacer-md) var(--spacer-lg);
}
</style>
